module.exports = __webpack_public_path__ + "img/share.e31ea254.svg";